import { FormattedMessage } from "react-intl"

export const ARR_STATUS_RECORD = [
    { name: <FormattedMessage id="actived" />, code: 1, color: 'success' },
    { name: <FormattedMessage id="deactived" />, code: 2, color: 'danger' },
];

export const ACTIVE_STATUS = 1;
export const DE_ACTIVE_STATUS = 2;